import LoginCard from 'containers/ac-containers/login';
import { View } from 'containers/ac-containers/login/interface';
import { useTranslation } from 'hooks/use-translation';
import React, { useState } from 'react';
import styles from './styles.scss';

const LoginBannerImg = 'https://web-data.zmlearn.com/image/n1Vfx6CnjH7iaxrow2x3vQ/img_login%402x.png';
/**
 * 登录页
 */
export default function LandingHome() {
	const [view, setView] = useState<View>();
	const { transData } = useTranslation('login')

	return (
		<div className={`${styles.login_page} page-container`}>
			<div className={styles.body}>
				<div className={styles.content}>
					<div className={styles.right}>
						<LoginCard className={styles.card} onChange={setView} />
					</div>
					<div className={styles.left}>
						<div className={styles.banner}>
							<div className={styles.card}>
								<img src={LoginBannerImg} alt='' loading='lazy' />
							</div>
							<div className={styles.footer}>
								{transData.copyright}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
